var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Municipalities__View" },
    [
      _c("EntityListLayout", {
        ref: "entity",
        attrs: { tabs: _vm.tabs, noPaging: true },
        on: { onNewEntitySave: _vm.onNewEntitySave },
        scopedSlots: _vm._u(
          [
            {
              key: "title",
              fn: function() {
                return [_vm._v("עיריות")]
              },
              proxy: true
            },
            _vm.isAdmin
              ? {
                  key: "button",
                  fn: function() {
                    return [
                      _c("b-button", { on: { click: _vm.showNewEntity } }, [
                        _vm._v("הוספת עיריה חדשה")
                      ])
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "counter",
              fn: function(slotProps) {
                return [
                  _vm._v(' סה"כ '),
                  _c("b", [
                    _vm._v(_vm._s(_vm.getTotalRecords(slotProps)) + " ")
                  ])
                ]
              }
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }